import { rtkApi as api } from '../rtkApi';

export interface ActivityEvent {
  _id: string;
  contractId: string;
  type: string;
  actorRole: 'buyer' | 'seller' | 'agent' | 'admin';
  actorName?: string;
  message?: string;
  meta?: any;
  createdAt: string;
}

export interface ListActivityResponse {
  success: boolean;
  data: ActivityEvent[];
  count: number;
}

export const activityApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getContractActivity: builder.query<ListActivityResponse, string>({
      query: (contractId) => ({
        url: `/activity/contract/${contractId}`,
        method: 'GET',
      }),
      providesTags: ['ContractActivity'],
    }),
  }),
  overrideExisting: true,
});

export const { useGetContractActivityQuery } = activityApi;
